import { generatePath } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import Heading from '@zenbusiness/zui/Heading';
import Link from '@zenbusiness/zui/Link';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as ROUTES from '#client/constants/routes';

import { useProductLandingContext } from '../../contexts/useProductLanding';
import { useProductLandingClickstreamProps } from '../../hooks/useProductLandingClickstreamProps';

function AssistanceSection() {
  const { productConfig } = useProductLandingContext();
  const personalizationClickstreamProps = useProductLandingClickstreamProps();
  const { assistance } = productConfig;

  if (!assistance) {
    return null;
  }

  const baseItem = {
    icon: assistance.icon ?? '/s2/material-icons/assistantrounded.svg',
    title: assistance.getInTouch,
    actions: assistance.actions,
    href: generatePath(ROUTES.help)
  };

  const extraItems = (assistance.additionalAssistance || []);
  const items = [baseItem, ...extraItems];

  return (
    <Stack gap={4} marginBlockStart={4}>
      <Heading component="h2" size="xl" wrap="wrap">
        <FormattedMessage id={assistance.title} />
      </Heading>
      <Stack
        gap={2}
        direction="column"
        sx={{
          flexDirection: { xs: 'column', md: 'row' }
        }}
      >
        {items.map((item) => (
          <Link
            key={item.href}
            href={item.href}
            target="_blank"
            clickstreamProps={{
              ...personalizationClickstreamProps,
              elementName: 'assistance_link',
              elementPosition: 'assistance',
              destination: item.href,
              elementText: item.title
            }}
            sx={{ textDecoration: 'none', flex: 1 }}
          >
            <Card sx={{ padding: 2 }}>
              <Stack gap={2} direction="row" alignItems="center" sx={{ marginBottom: '0.75rem' }}>
                <Box width={{ xs: '1.375rem', md: '2rem' }} height={{ xs: '1.375rem', md: '2rem' }}>
                  <SharedAsset alt="" aria-hidden src={item.icon} width="100%" height="100%" />
                </Box>
                <Text size="md" weight="medium" color="secondary"><FormattedMessage id={item.title} /></Text>
              </Stack>
              <Text
                size="sm"
                color="blue"
                weight="medium"
              >
                <FormattedMessage id={item.actions} />
              </Text>
            </Card>
          </Link>
        ))}
      </Stack>
    </Stack>
  );
}

export default AssistanceSection;
